import { render } from "./MainBannerDual.vue?vue&type=template&id=5abee6b3&scoped=true"
import script from "./MainBannerDual.vue?vue&type=script&lang=js"
export * from "./MainBannerDual.vue?vue&type=script&lang=js"

import "./MainBannerDual.vue?vue&type=style&index=0&id=5abee6b3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5abee6b3"]])

export default __exports__